export const MainSettings = {
  header: {
    logo: "/images/logo.png",
    routes: ["catalog", "FAQ", "guarante", "contacts"],
  },
  footer: {
    logo: "",
    payLogos: ["", "", "", ""],
  },
};
